var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDomainsHunts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 0.375V1.875C11.625 2.27282 11.467 2.65436 11.1857 2.93566C10.9044 3.21696 10.5228 3.375 10.125 3.375H1.875C1.47718 3.375 1.09564 3.21696 0.81434 2.93566C0.533035 2.65436 0.375 2.27282 0.375 1.875V0.375",
    stroke: "#00B578",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6.75C9.375 8.625 7.86375 11.625 6 11.625C4.13625 11.625 2.625 8.625 2.625 6.75C2.625 5.85489 2.98058 4.99645 3.61351 4.36351C4.24645 3.73058 5.10489 3.375 6 3.375C6.89511 3.375 7.75355 3.73058 8.38649 4.36351C9.01942 4.99645 9.375 5.85489 9.375 6.75Z",
    stroke: "#00B578",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.125C6.62132 10.125 7.125 9.62132 7.125 9C7.125 8.37868 6.62132 7.875 6 7.875C5.37868 7.875 4.875 8.37868 4.875 9C4.875 9.62132 5.37868 10.125 6 10.125Z",
    stroke: "#00B578",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 1.875V3.375",
    stroke: "#00B578",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 1.875V3.375",
    stroke: "#00B578",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80859 4.875H11.6248C11.6248 5.47174 11.3878 6.04403 10.9658 6.46599C10.5439 6.88795 9.97158 7.125 9.37484 7.125",
    stroke: "#00B578",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19125 4.875H0.375C0.375 5.47174 0.612053 6.04403 1.03401 6.46599C1.45597 6.88795 2.02826 7.125 2.625 7.125",
    stroke: "#00B578",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainsHunts);
export default __webpack_public_path__ + "static/media/domainsHunts.35c7ee55d10fe978976c1d024641803e.svg";
export { ForwardRef as ReactComponent };